import { render } from "./GoalTabSet.vue?vue&type=template&id=24038a98"
import script from "./GoalTabSet.vue?vue&type=script&lang=js"
export * from "./GoalTabSet.vue?vue&type=script&lang=js"
script.render = render

export default script